import React from 'react';
import { Loader } from '../../../../components/loader/Loader';
import styles from './folder_drop_loading.module.scss';

export function AddToFolderDropdownLoading() {
  return (
    <div className={styles.loader}>
      <Loader />
    </div>
  );
}
